import { BonusFeatureWonActionHandler, type ReplayPlugin } from "@slot/client-engine";
import type { FeatureStateStore } from "../../feature-state/FeatureStateStore";
import type { FeatureFinishedTransition } from "../feature-finished/FeatureFinishedPlugin";
import type { FeatureTriggerPresenter } from "./FeatureTriggerPresenter";

/**
 * The feature-trigger panel on `bonus_feature_won`. A retrigger (the feature is already active)
 * skips the music swap and the mode transition; a real base→feature trigger plays the transition
 * on dismiss.
 */
export function createFeatureTriggerPlugin(deps: { presenter: FeatureTriggerPresenter; featureStateStore: FeatureStateStore; transition: FeatureFinishedTransition }): ReplayPlugin {
  return {
    name: "feature-trigger",
    actionHandlers: [
      new BonusFeatureWonActionHandler(async (featureId, featureCount) => {
        const isRetrigger = deps.featureStateStore.isFeatureActive();
        const onDismissed = isRetrigger
          ? undefined
          : () => {
              void deps.transition.presentTransition();
            };
        await deps.presenter.presentFeatureWon(featureId, featureCount, onDismissed, isRetrigger);
      }),
    ],
  };
}
